<template>
  <a-form :form="form" @submit.prevent="onSubmit" layout="vertical">
    <a-row :gutter="16">
      <a-col :span="13">
        <a-form-item v-bind="errorsBind('non_field_errors')" />
        <a-form-item label="Rodzaj kursu">
          <a-radio-group
            name="is_group"
            v-model="form.is_group"
            :defaultValue="false"
          >
            <a-radio :value="false">Indywidualny</a-radio>
            <a-radio :value="true">Grupowy</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-bind="errorsBind('name')" label="Nazwa kursu" required>
          <a-input v-model="form.name" />
        </a-form-item>

        <a-form-item v-bind="errorsBind('lecturer')" label="Lektor" required>
          <a-select
            v-model="form.lecturer"
            :options="lecturers"
            showSearch
            optionFilterProp="children"
          />
        </a-form-item>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item v-bind="errorsBind('language')" label="Język" required>
              <a-select
                v-model="form.language"
                optionFilterProp="children"
                :disabled="languagesTaught.length === 0"
                :options="languagesTaught"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item v-bind="errorsBind('level')" label="Poziom" required>
              <a-select
                v-model="form.level"
                :options="levels"
                :disabled="levels.length === 0"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <a-form-item
          required
          v-bind="errorsBind('students')"
          :label="form.is_group ? 'Kursanci' : 'Kursant'"
        >
          <a-select
            v-if="form.is_group"
            showSearch
            optionFilterProp="children"
            @change="studentsChanged"
            :value="form.students"
            :options="students"
            mode="multiple"
          />
          <a-select
            v-else
            @change="studentsChanged"
            showSearch
            optionFilterProp="children"
            :value="form.students"
            :options="students"
          />
        </a-form-item>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item
              v-bind="errorsBind('hours')"
              label="Liczba godzin lekcyjnych"
              required
            >
              <a-input v-model="form.hours" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              v-bind="errorsBind('deadline')"
              label="Termin wykorzystania godzin"
            >
              <date-picker
                class="fluid"
                :allowClear="false"
                v-model="form.deadline"
                placeholder="Data zakończenia kursu"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <a-button type="primary" html-type="submit" :disabled="!isDirty">
          <span>Zapisz</span>
        </a-button>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import FieldHelper from '@/components/common/forms/FieldsHelper'
import { Language, LanguagesTaught, Lecturer, Student } from '@/api'

export default {
  extends: FieldHelper,
  data() {
    return {
      lecturers: [],
      students: [],
      languages: [],
      languagesTaught: [],
      availableLevels: []
    }
  },
  created() {
    if (this.$route.query.student) {
      this.form.students = [parseInt(this.$route.query.student)]
    }
    if (this.$route.query.lecturer) {
      this.$set(this.form, 'lecturer', parseInt(this.$route.query.lecturer))
    }

    this.fetchLanguages()
    this.fetchLecturers()
    this.fetchStudents()
  },
  methods: {
    fetchLecturers() {
      Lecturer.all().then(res => {
        this.lecturers = res.data.results.map(lecturer => ({
          label: lecturer.full_name,
          value: lecturer.id
        }))
      })
    },
    fetchStudents() {
      Student.all().then(res => {
        this.students = res.data.results.map(student => ({
          label: student.full_name,
          value: student.id
        }))
      })
    },
    studentsChanged(value) {
      if (Array.isArray(value)) {
        this.$set(this.form, 'students', value)
      } else {
        this.$set(this.form, 'students', [value])
      }
    },
    fetchLanguages() {
      Language.all().then(res => {
        this.languages = res.data.results.map(item => ({
          label: item.name,
          value: item.id
        }))
      })
    },
    fetchLanguagesTaught() {
      LanguagesTaught.all({
        lecturer: this.form.lecturer
      }).then(res => {
        this.languagesTaught = res.data.results.map(item => ({
          label: item.str,
          value: item.language,
          levels: item.levels
        }))
        const validLanguage = this.languagesTaught.find(
          language => language.value == this.form.language
        )
        if (!validLanguage) {
          this.$delete(this.form, 'language')
          this.$delete(this.form, 'level')
        }
      })
    }
  },
  computed: {
    levels() {
      const selectedLanguage = this.form.language
      if (selectedLanguage) {
        const languageOption = this.languagesTaught.find(
          language => language.value === selectedLanguage
        )
        if (languageOption) {
          return languageOption.levels.map(level => ({
            label: level,
            value: level
          }))
        }
      }
      return []
    }
  },
  watch: {
    'form.is_group'(value) {
      if (!value && this.form.students && this.form.students.length > 1) {
        this.form.students.splice(1)
      }
    },
    'form.lecturer': {
      immediate: true,
      handler(value) {
        if (!value) {
          return
        }
        this.fetchLanguagesTaught()
      }
    }
  }
}
</script>
